import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Scripts } from '@core/data-access/models/script-injector.model';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScriptsAPI {
  readonly #http = inject(HttpClient);

  getOperatorScripts$() {
    return this.#http.get<string[]>(`${environment.protocol}${environment.webApiUrl}/operator/scripts`);
  }

  getEventScripts$(eventId: number) {
    return this.#http.get<Scripts>(`${environment.protocol}${environment.webApiUrl}/event/${eventId}/scripts`);
  }
}
